import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import collect from 'collect.js';
import moment from 'moment';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import imgPreview from '@/views/components/imgPreview';
import { noop, parseSec } from '@/util';

@DialogFactory
@Component({
  mixins: [style],
})
export default class PeriodicalLink extends IPSDialog {
  sgId: number;

  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '期刊列表';

  width = '850px';

  cancelText = '关闭';
  // 是否是期刊橱窗
  showwindow = false;

  tableSelected = [];

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;

  mounted() {
    this.defaultStart = parseSec(3);
    this.defaultEnd = parseSec(4);
    this.date = [this.defaultStart, this.defaultEnd];
    this.getDataList();
    this.showwindow ? (this.confirm = true) : (this.confirm = false);
  }

  getDataList() {
    const postParams = {
      keyword: this.keyword,
      sgId: this.sgId,
      pageNum: this.pageSize,
      page: this.page,
      qiKanState: 1,
      sort: 0,
      siteCodes: this.siteCodes,
    };
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('更新时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        return;
      }
    }
    this.dataList = [];
    IPSService.getPeriodicalList({ postParams }).then((response) => {
      this.total = response.count;
      this.dataList = collect(response.list)
        .each((item) => {
          // item.qiKanEndTime = moment(item.qiKanEndTime * 1000).format('YYYY-MM-DD HH:mm:ss');
          item.date = `${item.createdTime}~${item.qiKanEndTime}`;
        })
        .values()
        .toArray();
    });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getDataList();
  }

  onPageChange(val) {
    this.page = val;
    this.getDataList();
  }

  handleSearch() {
    this.page = 1;
    this.getDataList();
  }

  onSelected(val) {
    this.tableSelected = val;
  }

  onConfirm() {
    this.$emit('result', this.tableSelected);
    this.$emit('hidden');
  }

  onSelect(row) {
    const id = row.qiKanId;
    const name = row.qiKanContent;
    this.$emit('result', { id, name });
    this.$emit('hidden');
  }

  onImgPreview(img) {
    imgPreview.open({ img }).then(noop, noop);
  }
  public dateChange() {
    this.page = 1;
    this.getDataList();
  }
  renderContent(h) {
    return this.showwindow ? (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="期刊编号/期刊描述"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
          <div class="inputWrapper wid-220">
            <span class="font-size-14 r-ml-10">更新时间</span>
            <el-date-picker v-model={this.date} type="daterange" format="yyyy 年 MM 月 dd 日" onChange={this.dateChange} range-separator="~" />
          </div>
        </div>
        <el-table data={this.dataList} on-selection-change={this.onSelected.bind(this)} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column type="index" label="ID" width="40" />
          <el-table-column prop="qiKanId" label="期刊编号" width="100px" show-overflow-tooltip></el-table-column>
          <el-table-column prop="qiKanContent" label="期刊描述" show-overflow-tooltip width="280px"></el-table-column>
          <el-table-column prop="date" align="center" label="有效期" width="400px" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    ) : (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="期刊编号/期刊描述"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
          <div class="inputWrapper wid-220">
            <span class="font-size-14 r-ml-10">更新时间</span>
            <el-date-picker v-model={this.date} type="daterange" format="yyyy 年 MM 月 dd 日" onChange={this.dateChange} range-separator="~" />
          </div>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="40" />
          <el-table-column prop="qiKanId" label="期刊编号" width="80px"></el-table-column>
          <el-table-column prop="qiKanContent" label="期刊描述" show-overflow-tooltip width="250px"></el-table-column>
          <el-table-column prop="date" align="center" label="有效期" width="400px" show-overflow-tooltip></el-table-column>
          <el-table-column
            align="center"
            label="操作"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row)}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
